import { render, staticRenderFns } from "./Coverv2.vue?vue&type=template&id=c0af17b8&scoped=true"
import script from "./Coverv2.vue?vue&type=script&lang=js"
export * from "./Coverv2.vue?vue&type=script&lang=js"
import style0 from "./Coverv2.vue?vue&type=style&index=0&id=c0af17b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0af17b8",
  null
  
)

export default component.exports